export const changeText = (text: any) => {
  return text
    ?.split('\n')
    .join('')
    ?.split('\b')
    .join('')
    ?.split('\\')
    .join('');
};
